const initializeStickyPurchaseBar = () => {
	const baseTransition = '0.3s ease max-height'
	const mainProductSection = document.querySelector(
		'[data-section-type="main-product"]'
	)
	if (!mainProductSection || mainProductSection.dataset.enableStickyForm !== 'true') return
	if (!mainProductSection) {
		return console.error(
			'Error setting up sticky purchase bar: missing main product section'
		)
	}
	const productPurchaseForm =
		mainProductSection.querySelector('.buy-buttons-row')
	const productTitle = mainProductSection.querySelector('.title-row h1')
	const productTitleContent = productTitle?.textContent

	const productCampaign = productPurchaseForm.querySelector('product-campaign')

	if (!productPurchaseForm || !productTitle || !productTitleContent) {
		return console.error(
			'Error setting up sticky purchase bar: missing elements'
		)
	}

	const productPurchaseButton = productPurchaseForm.querySelector(
		'button[type="submit"]'
	)

	if (!productPurchaseButton) {
		return console.error(
			'Error setting up sticky purchase bar: missing elements'
		)
	}

	// Setup base container
	const container = document.createElement('div')
	container.classList.add('sticky-purchase-container', 'product-detail')
	container.style.maxHeight = '0px'

	const containerForm = document.createElement('div')
	containerForm.classList.add('product-form')
	const containerTop = document.createElement('div')
	containerTop.classList.add('sticky-product-top', 'container')

	// Top area contains title and price
	const containerTopArea = document.createElement('div')
	containerTopArea.classList.add('sticky-product-top-area')
	containerTop.appendChild(containerTopArea)

	// Middle area contains purchase button and options toggle
	const containerMiddleArea = document.createElement('div')
	containerMiddleArea.classList.add('sticky-product-middle-area')
	containerTop.appendChild(containerMiddleArea)

	// Product title
	const productTitleContainer = document.createElement('p')
	productTitleContainer.classList.add('sticky-product-title')
	productTitleContainer.textContent = productTitleContent
	containerTopArea.appendChild(productTitleContainer)

	// Product price container
	const productPriceContainer = document.createElement('div')
	productPriceContainer.classList.add('sticky-product-price-container')
	containerTopArea.appendChild(productPriceContainer)

	let animationState = {
		showTopArea: false,
		showMiddleArea: false,
		buttonIsAbove: false,
		titleIsAbove: false,
	}

	const toggleOptions = (forceClose) => {
		const options = containerForm.querySelector('.sticky-product-options')
		const toggle = containerForm.querySelector('.sticky-options-toggle')
		if (!options || !toggle) {
			return
		}
		const isOpen = forceClose || options.dataset.open === 'true'
		options.dataset.open = isOpen ? 'false' : 'true'
		toggle.dataset.open = isOpen ? 'false' : 'true'
		if (!isOpen) {
			container.style.maxHeight = 'none'
		} else {
			container.style.maxHeight = `${
				animationState.containerHeight ?? 0
			}px`
		}
	}

	// Variant options toggle
	const productOptions = mainProductSection.querySelectorAll(
		'.input-row .option-selectors .option-selector'
	)
	const optionsToggle = document.createElement('button')
	optionsToggle.classList.add('sticky-options-toggle')
	optionsToggle.type = 'button'
	optionsToggle.addEventListener('click', () => toggleOptions())
	if (productOptions.length > 0) {
		containerMiddleArea.appendChild(optionsToggle)
	}

	// Purchase button
	const stickyPurchaseButton = document.createElement('button')
	stickyPurchaseButton.classList.add('sticky-add-to-cart')
	stickyPurchaseButton.type = 'button'
	stickyPurchaseButton.textContent = productPurchaseButton.textContent

	stickyPurchaseButton.addEventListener('click', () => {
		productPurchaseButton.click()
	})
	containerMiddleArea.appendChild(stickyPurchaseButton)

	// Clone and append product campaign if it exists
	let stickyProductCampaign = null
	if (productCampaign) {
		stickyProductCampaign = productCampaign.cloneNode(true)
		containerMiddleArea.appendChild(stickyProductCampaign)

		// Watch for height changes in the campaign element
		const campaignObserver = new ResizeObserver(() => {
			// Trigger animation update when campaign size changes
			animate(animationState, true)
		})
		campaignObserver.observe(stickyProductCampaign)
	}

	// Product options
	const stickyProductOptions = document.createElement('div')
	stickyProductOptions.classList.add('sticky-product-options')
	const stickyProductOptionSelectors = document.createElement('div')
	stickyProductOptionSelectors.classList.add(
		'sticky-product-option-selectors'
	)
	stickyProductOptions.appendChild(stickyProductOptionSelectors)

	// Wishlist group
	/*const productWishlistGroup = mainProductSection.querySelector(
		'.product-wishlist-group'
	)
	if (productWishlistGroup) {
		stickyProductOptions.appendChild(productWishlistGroup.cloneNode(true))
	}*/

	// Update price by cloning original price
	const updatePrice = () => {
		const productPriceArea = mainProductSection.querySelector('.price-area')
		if (!productPriceArea) {
			return
		}
		productPriceContainer.innerHTML = ''
		productPriceContainer.appendChild(productPriceArea.cloneNode(true))
	}

	// Update options by cloning original options
	const updateOptions = () => {
		const productOptions = mainProductSection.querySelectorAll(
			'.input-row .option-selectors .option-selector'
		)
		if (!productOptions.length > 0) {
			return
		}

		// Clear previous options
		stickyProductOptionSelectors.innerHTML = ''

		productOptions.forEach((option) => {
			const clonedOption = option.cloneNode(true)

			// Rename ids for inputs and labels
			const inputs = clonedOption.querySelectorAll('input')
			inputs.forEach((input) => {
				const originalId = input.id
				const originalName = input.name
				const originalInput = option.querySelector(`#${originalId}`)
				const label = clonedOption.querySelector(
					`label[for="${originalId}"]`
				)
				if (!label) return
				const newId = `sticky-${originalId}`
				const newName = `sticky-${originalName}`
				input.id = newId
				input.name = newName
				input.setAttribute('aria-labelledby', newId)
				label.htmlFor = newId
				// Add event listener to trigger original option
				input.addEventListener('change', () => {
					originalInput.click() // Simulate click on original input
				})

				// Add event listener to trigger sticky option
				originalInput.addEventListener('change', (event) => {
					setTimeout(() => {
						variantChangedCallback()
					}, 100)
				})
			})

			stickyProductOptionSelectors.appendChild(clonedOption)
		})
	}

	const variantChangedCallback = () => {
		// Update price
		updatePrice()

		// Update options
		updateOptions()
	}

	variantChangedCallback()

	const animate = (state, removeCssTransition = false) => {
		if(removeCssTransition) {
			container.style.transition = 'none'
		}
		toggleOptions(true)
		let newContainerHeight = 0
		const wasAtTop =
			animationState.titleIsAbove && animationState.showTopArea
		const showAtTop = state.titleIsAbove && state.showTopArea
		const topPadding = 16
		const gap = 8
		if (state.showTopArea) {
			newContainerHeight += containerTopArea.offsetHeight + topPadding
		}
		if (state.showMiddleArea) {
			const middlePadding = state.showTopArea ? gap : gap * 2
			newContainerHeight +=
				containerMiddleArea.offsetHeight + middlePadding
		}

		if ((state.showTopArea || state.showMiddleArea) && !showAtTop) {
			container.style.borderTop = '1px solid #e0e0e0'
			container.style.borderBottom = 'none'
		} else {
			container.style.borderBottom = '1px solid #e0e0e0'
			container.style.borderTop = 'none'
		}

		if (!showAtTop && !state.showTopArea) {
			// Push the top area out of view
			containerForm.style.transform = `translateY(-${
				containerTopArea.offsetHeight + gap
			}px)`
		} else {
			containerForm.style.transform = `translateY(0)`
		}

		if (showAtTop) {
			const pageHeaderHeight =
				document.getElementById('pageheader').offsetHeight
			container.style.top = `${pageHeaderHeight}px`
			container.style.bottom = 'unset'
		} else if (wasAtTop) {
			setTimeout(() => {
				// Delay movement until animation is finished
				container.style.top = 'unset'
				container.style.bottom = '0'
			}, 300)
		} else {
			container.style.top = 'unset'
			container.style.bottom = '0'
		}

		container.style.maxHeight = `${newContainerHeight}px`
		animationState = {
			...state,
			containerHeight: newContainerHeight,
		}
		if(removeCssTransition) {
			// Restore the original transition after a short delay
			setTimeout(() => {
				container.style.transition = baseTransition;
			}, 50);
		}
	}

	containerForm.appendChild(containerTop)
	containerForm.appendChild(stickyProductOptions)
	container.appendChild(containerForm)

	document.body.appendChild(container)

	// Detect when purchase button is out of view
	const buttonObserver = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					animate({
						...animationState,
						showMiddleArea: false,
						buttonIsAbove: entry.boundingClientRect.top < 0,
					})
				} else {
					animate({
						...animationState,
						showMiddleArea: true,
						buttonIsAbove: entry.boundingClientRect.top < 0,
					})
				}
			})
		},
		{ threshold: 0.5 }
	)

	// Detect when title is out of view
	const titleObserver = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					animate({
						...animationState,
						titleIsAbove: entry.boundingClientRect.top < 0,
						showTopArea: false,
					})
				} else {
					animate({
						...animationState,
						titleIsAbove: entry.boundingClientRect.top < 0,
						showTopArea: true,
					})
				}
			})
		},
		{ threshold: 0.5 }
	)

	buttonObserver.observe(productPurchaseButton)
	titleObserver.observe(productTitle)
}

if (
	window.theme.template.name === 'product' ||
	window.theme.template.name === 'collection'
) {
	initializeStickyPurchaseBar()
}
